import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=ae07c7e6&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae07c7e6')) {
      api.createRecord('ae07c7e6', component.options)
    } else {
      api.reload('ae07c7e6', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=ae07c7e6&", function () {
      api.rerender('ae07c7e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4C2EbMGq4iy33/JS/comp/cancellationPolicy.vue"
export default component.exports